import Validator from 'validatorjs'
import formatErrors from './formatErrors'

const rules = {
  username: 'required|string',
  password: 'required|string',
  email: 'required|email',
  mobile: 'required|numeric',
  terms: 'accepted'
}

export default function validateUser (values) {
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    email: 'فرمت ایمیل صحیح نمی باشد',
    numeric: 'این فیلد می‌بایست عدد باشد',
    accepted: 'پذیرش قوانین برای استفاده از خدمات سایت الزامی است'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateUser.js